import { API_ENDPOINTS, buildApiUrl } from "../utils/api-config";
import { getAuthToken } from "./api";

export const getAllTansformationMaturity = async (customer_id:string , transformation_maturity_id:string) => {
    try {
        const { userId, idToken } = await getAuthToken();
        if (!idToken) {
            throw new Error('No ID token found in session');
        }
        const params = new URLSearchParams({
            transformation_maturity_id:transformation_maturity_id
        })
        const transformation_url = buildApiUrl(API_ENDPOINTS.GET_CUSTOMER_MATURITY_TRANSFORMATION(customer_id))
        const response = await fetch(`${transformation_url}?${params}`, {
            headers: {
                "Content-Type": "application/json",
                Accept: "application/json",
                "user-id": userId,
                Authorization: `Bearer ${idToken}`
            },
            
        });
        if (!response.ok) {
            throw new Error(`Failed to fetch transformation data: ${response.status} ${response.statusText}`);
        }
        return await response.json();
    } catch (error) {
        console.log(error)
    }
}

/**
 * Updates a single transformation maturity item
 * @param customer_id The customer ID
 * @param data The transformation maturity data to update
 * @returns The response from the API
 */
export const updateTransformationMaturity = async (
  customer_id: string,
  data: {
    transformation_maturity_id: string;
    label: string;
    step_id: string;
    transformation_area: string;
    growth: string;
    notes: string;
  }
) => {
  try {
    const { userId, idToken } = await getAuthToken();
    if (!idToken) {
      throw new Error('No ID token found in session');
    }
    
    const response = await fetch(buildApiUrl(API_ENDPOINTS.CUSTOMER_MATURITY_TRANSFORMATION(customer_id)), {
      method: 'POST',
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        "user-id": userId,
        Authorization: `Bearer ${idToken}`
      },
      body: JSON.stringify(data),
    });
    
    if (!response.ok) {
      throw new Error(`Failed to update transformation data: ${response.status} ${response.statusText}`);
    }
    
    return await response.json();
  } catch (error) {
    console.error('Error updating transformation maturity:', error);
    throw error;
  }
};
